import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'

export const ImageList = () => (
    <div>
      <h3>SELECT A CATEGORY</h3>

      <ul className='image-list'>
        <li><Link to={prefixLink('/images/quebec-photos/')}>QUÉBEC</Link></li>
        <li><Link to={prefixLink('/images/maine-photos/')}>MAINE</Link></li>
        <li><Link to={prefixLink('/images/silos-photos/')}>SILOS</Link></li>
        <li><Link to={prefixLink('/images/cemeteries-photos/')}>CEMETERIES</Link></li>
        <li><Link to={prefixLink('/images/trees-photos/')}>TREES</Link></li>
        <li><Link to={prefixLink('/images/ice-shacks-photos/')}>ICE SHACKS</Link></li>
        <li><Link to={prefixLink('/images/miscellaneous-photos/')}>MISCELLANEOUS</Link></li>
      </ul>
    </div>
)



// WEBPACK FOOTER //
// ../components/ImageList.js